module.exports = __webpack_public_path__ + "img/game.c7f135f8.svg";